module.exports = __webpack_public_path__ + "static/img/pc_img_logo_content_unlock.703f5aca.png";